/** Normalize list payload from GET /customers/fetch-all */
export function normalizeCustomersList(payload) {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.items)) return payload.items;
  if (Array.isArray(payload.customers)) return payload.customers;
  if (Array.isArray(payload.data)) return payload.data;
  return [];
}

export function unwrapCustomerDetail(data) {
  if (!data || typeof data !== "object") return null;
  if (data.customer && typeof data.customer === "object") return data.customer;
  if (data.data && typeof data.data === "object") return data.data;
  return data;
}

export function getCustomerId(item) {
  return item?.id ?? item?.customer_id ?? item?.uuid ?? "";
}

export function getCustomerNome(item) {
  return item?.NOME_PESSOA_FISICA ?? item?.nome ?? "";
}

export function getCustomerCpf(item) {
  return item?.CPF_PESSOA_FISICA ?? item?.cpf ?? "";
}
